import { Component, OnInit, OnDestroy, HostListener,ViewChild, EventEmitter, Output } from '@angular/core';
import { NavigationService } from '../../../../services/navigation.service';
import { SharedService } from '../../../../../services/shared.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faExchangeAlt, faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router, Route, NavigationEnd, NavigationStart } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToastrUtilityService } from 'src/app/services/toastr-utility.service';
import { FontawesomeService } from 'src/app/dce-views/dynamic-form/fontawesome.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { EnvService } from 'src/app/services/env.service';
// import { ManageComponentStateService } from 'src/app/dce-service/manage-component-state.service';
// import { AuthService } from '../../../../services/auth.service';
// import { QueueSessionRenderComponent } from 'src/app/dce-views/live-chat/queue-session-render/queue-session-render.component';
// import { SideContainerComponent } from 'src/app/dce-shared/side-container/side-container.component';
// import { SipRenderComponent } from 'src/app/dce-views/jssip/sip-render/sip-render.component';
// import { EnvService } from 'src/app/dce-service/env.service';

declare var $:any;
type tele_emitter_data = {
    extension: string,
    queues: Array<string>,
    tele_call_id: string,
    previous_tele_call_id: string,
    call_session_close_status: string,
}
@Component({
  selector: 'app-header-sidebar-large',
  templateUrl: './header-sidebar-large.component.html',
  styleUrls: ['./header-sidebar-large.component.scss']
})
export class HeaderSidebarLargeComponent implements OnInit, OnDestroy {

  // @ViewChild(SideContainerComponent ,{static: false}) sideContainer: SideContainerComponent;
  // @ViewChild(SipRenderComponent ,{static: false}) sipComp: SipRenderComponent;
  // @ViewChild(QueueSessionRenderComponent ,{static: false}) queueSessionRender: QueueSessionRenderComponent;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    // const data:tele_emitter_data = {
    //   // extension: this._sharedService.check_dt_role_access('87__87001') ? this._shared.sip_storage.authorization_user : null,
    //   // queues: this._shared.sip_storage.agent_queues,
    //   // tele_call_id: this._shared.sip_storage.call_id,
    //   // previous_tele_call_id: this._shared.sip_storage.previous_call_id,
    //   call_session_close_status: 'Abrupt Termination',
    // }
    // this._socket_service.tele_socket_emit('dce_app_refresh', data);
    // this.signout();
  }

    notifications: any = [];
    user_name = '';
    user_email = '';
    user_full_name = '';
    recent_notifications = [];
    unread_notification = 0
    interval_obj: any;
    profiles = [];
    current_profile = {
      role_id : -1,
      role_name: ''
    };
    visible_bool = false;
    selected_role_id: any = null

    constructor(
      private navService: NavigationService,
      private auth: AuthService,
      public _shared: SharedService,
      private _commonService: CommonService,
      private _env: EnvService,
      // private sanitizer:DomSanitizer,
      private library: FaIconLibrary,
      // private _router: Router,
      // private _sharedService: SharedService,
      // private _toastr: ToastrService,
      // private _toastrUtility: ToastrUtilityService,
      public fa:FontawesomeService,
      private _router : Router
      // private _componentState: ManageComponentStateService,
    ) {
      library.addIcons(faExchangeAlt, faTimes, faUser );
    }
  
    ngOnInit() {
      const user_details = this._shared.getValue('user_details');
      console.log(user_details)
      this.user_name = user_details.first_name + ' ' + user_details.last_name;
      this.user_full_name = user_details.first_name + ' ' + user_details.last_name;
      // this.user_full_name = user_details.full_name;
      console.log(this.user_full_name)
      this.user_email = user_details.user_name;
      // this.get_notification();
      // this.get_notification_interval();
      this.get_profile_roles();
      // this.check_telephony();
      // this.login_confirmation_livechat();
    }

    ngOnDestroy() {
      clearInterval(this.interval_obj);
      // this.signout();
    }

    login_confirmation_livechat() {
      // if (this._shared.CONNECTOR_CONTROLS.LIVE_CHAT_SWITCH && this._sharedService.check_dt_role_access('87__87009')) {
        // this.open_livechat_login_modal();
      // }else {

      // }
    }

    check_telephony() {
      // if (this._shared.CONNECTOR_CONTROLS.TELEPHONY_SWITCH && this._sharedService.check_dt_role_access('87__87001')) { // check telephony-role attached

      //   if (this._shared.sip_storage.uri == null || this._shared.sip_storage.config_data == null) {
      //     this._toastr.error('', 'Telephony Details not found. Failed to start Telephony Interface.', this._toastrUtility.basic_configuration);
      //     return;
      //   }

      //   if (this._shared.sip_storage.telephony_keys == null) {
      //     this._toastr.error('', 'Telephony Details not linked to Default Workgroup. Failed to start Telephony Interface.', this._toastrUtility.basic_configuration);
      //     return;
      //   }

      //   if (this._shared.sip_storage.config_data.show_sip_login_modal) {
      //     // this.open_sip_login_modal();
      //   }

      // } else {
      //   // do nothing
      // }
    }
  
    get_notification(){
      this.unread_notification = 0;
      this.recent_notifications = [];
      // this._commonService.get_unread_push_notifications({'climit':10}).subscribe(res => {
      //   if (res.errCode == 0 ) {
      //     this.notifications = res.msg;
      //     this.unread_notification = res.unread_count
      //     for (let index = 0; index < this.notifications.length; index++) {
      //       const element = this.notifications[index];
      //       element.message = this.sanitizer.bypassSecurityTrustHtml(element.message)
      //       this.recent_notifications.push(element);
      //     }
      //   }
      // });
    }
    get_notification_interval() {
      // this.interval_obj = setInterval(()=>{
      //   this.get_notification();
      // },this._env.notification_interval)
    }

    mark_as_read_notfication(id,read_all) {
      const payload = {
        'notification_id_list': [id],
        'read_all':read_all
      };
      // this._commonService.mark_read_notifications(payload).subscribe(res => {
      //   if (res.errCode == 0) {
      //     for (let i = 0; i < this.recent_notifications.length; i++) {
      //       if (this.recent_notifications[i].id == id || read_all) {
      //         this.recent_notifications[i].status = "Read";
      //         if(!read_all){
      //           this.recent_notifications.splice(i,1)
      //           this.unread_notification -= 1;
      //           if(this.recent_notifications.length < 5){
      //             this.get_notification();
      //           }
      //           break;
      //         }
      //       }
      //     }
      //     if(read_all){
      //       this.unread_notification = 0;
      //     }
      //   }
      // })
    }

    toggelSidebar() {
      const state = this.navService.sidebarState;
      if (state.childnavOpen && state.sidenavOpen) {
        return state.childnavOpen = false;
      }
      if (!state.childnavOpen && state.sidenavOpen) {
        return state.sidenavOpen = false;
      }
      if (!state.sidenavOpen && !state.childnavOpen) {
          state.sidenavOpen = true;
      }
    }
  
    signout() {
      let tkn = this._shared.getToken()
      if (tkn != undefined) {
        this.logout();
      }
    }

    async logout() {
      // if (this.sipComp != undefined) {
      //   await this.sipComp.logout();
      // } // no need for explicit sip logout; as we dont allow user to logout of dce unless sip is logged-in
      const payload = {}; // will be set in future based on functionality during logging out.
      this.auth.logout(payload).subscribe(res => {
        if (res.errCode === 0) {
          // this._socket_service.tele_socket_session_close();
          this._shared.removeValue('token');
          // do nothing for now
          this.auth.signout();
          // this._componentState.removeState()
          // this.navService.sidebarState.showAnnouncement = false;
        }
      });
    }

    get_profile_roles() {
      this.profiles = this._shared.getValue('user_roles');
      console.log(this.profiles)
      const current_role = this._shared.getValue('current_role');
      console.log(current_role)
      console.log(this._shared.getValue('current_role'));
      console.log(this._shared.getValue('current_role'));
      this.current_profile.role_id = current_role.role_id;
      this.current_profile.role_name = current_role.role_name;
    }
    
    side_div_events(event) {
      switch(event.type){
        case 'close':
          this.visible_bool = false;
        break;
      }
    }

    // customer-info methods
    cus_info_toggler() {
      // this._shared.sip_storage.cus_info_toggle = !this._shared.sip_storage.cus_info_toggle;
    }

    sip_parent_events(e) {
      // const literal = {
      //   init: () => {
      //     // this.sip_wrapper.sip_user_config = this.uri_config;
      //   },
      //   mic_access: () => {
      //     if (!e.data) {
      //       this.close_sip_login_modal();
      //       this.open_force_mic_modal();
      //     }
      //   },
      //   sip_logout_modal: () => {
      //     this.open_sip_logout_modal();
      //   },
      //   repeat_caller_modal: () => {
      //     this.open_repeat_caller_modal();
      //   }
      // }
      // if (literal[e.case]) { //fail-safe
      //   return literal[e.case](this);
      // }
    }

    live_chat_parent_events(e) {
      console.log(e);
      const literal = {
        live_chat_logout_modal: () => {
          // this.open_live_chat_logout_modal();
        },
        live_chat_disconnect_modal: () => {
          // this.open_live_chat_disconnect_modal();
        },
      }
      if (literal[e.case]) { //fail-safe
        return literal[e.case](this);
      }
    }

    chat_popup_event(event) {
      switch (event.case) {
        case 'live_chat_disconnect_modal':
          // this.open_live_chat_disconnect_modal();
        break;
      }
    }

    open_switch_profile_modal(){
      $('#switchProfileModal').modal({ backdrop: 'static', keyboard: false });
    }

    close_switch_profile_modal(){
      $('#switchProfileModal').modal('hide');
      this.selected_role_id = 0
    }

    async switch_role(role_id) {
      this.selected_role_id = role_id
      if (!this._env.switch_role_logout_user) {
        this._commonService.get_data_after_refresh({'role_id': role_id }).subscribe(res => {
            window.location.reload();
        });
      }
      else{
      await this.allow_role_switch(role_id);
      }
     }

    async allow_role_switch(role_id) {
      const res = await this.reiniate_roles_sidebar({'role_id': role_id});
      // if (res.errCode === 0) {
      //   this.navService.sidebarState.showAnnouncement = false;
      // }
    }

    async reiniate_roles_sidebar(payload) {
      console.log("reinital roles sidebar " , payload)
      this._shared.spinnerVisibility(true)
      const get_user_rec = await this._shared.promise_fn(payload);
      console.log(get_user_rec)
      if (get_user_rec.errCode === 0) {
        // this.route_dashboard_skip_local();
        this.get_profile_roles();
        await this._shared.get_sidebar_tree();
        this._shared.spinnerVisibility(false)
        this.check_telephony();
      }
      return get_user_rec;
    }

    route_dashboard_skip_local() {
      this._router.navigateByUrl("/dashboard/v2", { skipLocationChange: true })
        .then(() => this._router.navigate(["/home/v1"]));
    }
}
